Vue.component("SplitContent", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition name="fadeinvideo">
            <div class="split-content" v-if="contentReady" :class="{'split-content--flipped': flipped}">
                <div class="split-content__mediawrapper">
                    <img v-if="media.endsWith('jpg') || media.endsWith('png')" :src="media">
                    <video id="split-content__video" autoplay loop type="video/mp4" v-if="media.endsWith('mp4')">
                        <source :src="media">
                    </video>
                    <div class="split-content__mediawrapper__fullscreen" 
                    v-if="allowfullscreen"
                    @click="showFullscreen">
                        <img src="assets/img/ui/fullscreen.png">
                    </div>
                </div>

                <div class="split-content__content_wrapper">
                    <div @click="close" class="split-content__btnClose">&times;</div>

                    <transition-group :name="contentTransitionName"> 
                        <section class="split-content__content" 
                            v-for="(content, i) in slides" 
                            :key="content.mainTitle"
                            v-show="activetab == i">
                            <h2 v-if="content.subTitle" v-html="content.subTitle"></h2>
                            <h1 v-html="content.mainTitle"></h1>
                            <p v-html="content.text"></p>
                        </section>
                    </transition-group>

                    <ul class="split-content__content_navigation">
                        <li v-for="(nav, i) in slides"
                        :class="{'split-content__content_navigation--active': activetab == i}" 
                        @click="changeTab(i)">
                            <span>{{nav.menuTitle ? nav.menuTitle : nav.mainTitle}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    `,
    data() {
        return {
            // variables for this instance of the split content
            contentReady: false,
            contentTransitionName: "contentslideright",
            activetab: 0,
            
            //content
            slides: [],
            
            //customization variables from manifest.
            flipped: false,
            allowfullscreen: false,
            media: ''
        }
    },
    mounted() {
        // hook for intro transition
        this.contentReady = true;
    },
    methods: {
        changeTab(i) {
            // animate change in componentm slides based on what direction the next slide is in.
            this.contentTransitionName = this.activetab < i ? "contentslideright" : "contentslideleft";
            this.activetab = i;
        },
        showFullscreen() {
            // show video in fullscreen. just html5 fullscreen.
            let vid = document.getElementById("split-content__video")
            if (vid.requestFullscreen) {
                vid.requestFullscreen();
            } else if (vid.mozRequestFullScreen) {
                vid.mozRequestFullScreen();
            } else if (vid.webkitRequestFullscreen) {
                vid.webkitRequestFullscreen();
            }
        }
    },
})

touchKit.ComponentManager.register("SplitContent", {singleton: true});